import React, { Component,Fragment } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { 
    fetchModalGoodsgroup,
    fetchGoods 
}     from '../../../store/actions/goodsActions';


class SearchGoodsListSelect extends Component {
	
	constructor(props) {
		super(props);
	    this.state = {
			isLoading:false,
			openSearcher:true,
			selected:"",
			goodsList: [],
            placeholder:'Buscar producto'
		}
    //     if(this.props.branch_group){
    //         this.props.fetchModalGoodsgroup(this.props.branch_group)
    //     }else{
    //         this.props.fetchGoods()
    //     }
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { goodsList, userHigherAccess } = this.props;
        // console.log("prev",prevProps.goodsList  && prevProps.goodsList.data && prevProps.goodsList.data[0] && prevProps.goodsList.data[0].id)
        // console.log("next",goodsList && goodsList.data && goodsList.data[0] && goodsList.data[0].id)
		if ((prevProps.goodsList  && prevProps.goodsList.data && prevProps.goodsList.data[0] && prevProps.goodsList.data[0].id) !== (goodsList && goodsList.data && goodsList.data[0] && goodsList.data[0].id) && userHigherAccess > BRANCH_ACCESS) {
            if(goodsList && goodsList.data){
                newList = goodsList.data.map(b => { return { access_id: b.id, related_access: b } })
                this.setState({ goodsList: newList })
            }
		}
	}

	SearchAction(query){
		let { userHigherAccess } = this.props;
		if(userHigherAccess > BRANCH_ACCESS){
            if(this.props.branch_group){
                this.props.fetchModalGoodsgroup(this.props.branch_group,1,query)
            }else{
                this.props.fetchGoods(1,query)
            }
		}
	}

	render () {
		return (
            <AsyncTypeahead
                ref={(ref) => this._typeahead = ref}
                labelKey="name"
                options={ this.state.goodsList.map($0 => $0.related_access)}
                onChange={this.props.change}
                onSearch={(query) => this.SearchAction(query)}
                isLoading={this.state.isLoading}
                value={this.state.selected}
                placeholder={this.state.placeholder} 
                renderMenuItemChildren={
                    (option, props, index) => <div className="normaltext-autocomplete" style={{display: `flex`,gap: `10px`}}>
                        <img className="avatar_small" 
                            src={option.picture_urls[0]} 
                            ref={ `avatar_url`}  
                            onError={ ()=>this.refs[`avatar_url`].src= 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png' }
                            alt={option.name}/>
                        <div style={{width: `calc(100% - 40px)`}}>
                            {option.name}<br/>
                            <small>{option.email}</small>
                        </div>
                    </div>
                }/>
		)	
	}
}


const mapStateToProps = (state) => {
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		errors: state.errors,
		json_lang: state.json_lang,
		goodsList:state.goodsList
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchGoods: (page,query) => dispatch(fetchGoods(page,query)), 
        fetchModalGoodsgroup: (branch_group,page,query) => dispatch(fetchModalGoodsgroup(branch_group,page,query)), 
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchGoodsListSelect);


// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchGoodsListSelect.js